document.addEventListener('DOMContentLoaded', () => {
  const popupBtns = document.querySelectorAll('.popupBtn');
  const perroBtn = document.getElementById('perroButton0001');
  const gatoBtn = document.getElementById('gatoButton0001');

  // Function to check and auto-click active perro/gato button
  function handleActivePetButton() {
    if (perroBtn.classList.contains('active-text0001')) {
      gatoBtn.style.display = 'none';
       perroBtn.style.display = 'none';
      perroBtn.click(); // auto-click perro
    } else if (gatoBtn.classList.contains('active-text0001')) {
      perroBtn.style.display = 'none';
        gatoBtn.style.display = 'none'; // Hide gatoBtn
      gatoBtn.click(); // auto-click gato
    }
  }

  // Handle popupBtn clicks
  popupBtns.forEach((btn, index) => {
    btn.addEventListener('click', () => {
      // Save which popup button was clicked
      localStorage.setItem('popupClicked', index);

      // Hide BOTH popup buttons
      popupBtns.forEach(otherBtn => {
        otherBtn.style.display = 'none';
      });

      // Run the pet button handler
      handleActivePetButton();
    });
  });
});






// Wait for the document to be fully loaded
document.addEventListener('DOMContentLoaded', () => {
  // Select all buttons with class 'popupBtn'
  const popupBtns = document.querySelectorAll('.popupBtn');

  // Get the Appa button by its ID
  const appaBtn = document.getElementById('appaBtn');

  // Loop through each button and attach the event
  popupBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      appaBtn.classList.remove('d-none');
    });
  });
});

 




document.addEventListener('DOMContentLoaded', () => {
    // Select all elements with the class "popupBtn"
    const popupButtons = document.querySelectorAll('.popupBtn');

    // Select the two buttons we want to check
    const perroButton = document.getElementById('perroButton0001');
    const gatoButton = document.getElementById('gatoButton0001');

    // Check if the target buttons exist
    if (!perroButton || !gatoButton) {
        console.log('One or more target buttons (perroButton0001 or gatoButton0001) were not found on the page.');
        return;
    }

    // Attach click event to each popupBtn
    popupButtons.forEach(btn => {
        btn.addEventListener('click', () => {
            let activeButton = 'None';

            if (perroButton.classList.contains('active-text0001')) {
                console.log('The PERRO button is currently active.');
                activeButton = 'PERRO';
            } else if (gatoButton.classList.contains('active-text0001')) {
                console.log('The GATO button is currently active.');
                activeButton = 'GATO';
            } else {
                console.log('Neither the PERRO nor the GATO button is active.');
            }

            // Save to localStorage
            localStorage.setItem('active-button', activeButton);
        });
    });

    // Optional: Log if no popupBtn elements were found
    if (popupButtons.length === 0) {
        console.log('No elements with class "popupBtn" were found.');
    }
});









document.addEventListener('DOMContentLoaded', () => {
    // Select the necessary elements
    const perroGramosSpan = document.querySelector('.gramos-value');
    const gatoGramosSpan = document.querySelector('.cat-gramos-value');
    const perroButton = document.getElementById('perroButton0001');
    const gatoButton = document.getElementById('gatoButton0001');
    const popupButtons = document.querySelectorAll('.popupBtn'); // 👈 Now selects all by class
    const gramosValueExtraSpan = document.querySelector('.gramos-value-extra');

    // Check if critical elements exist
    if (!perroButton || !gatoButton) {
        console.error('Required buttons (perroButton0001 or gatoButton0001) not found.');
        return;
    }

    if (popupButtons.length === 0) {
        console.error('No elements found with class "popupBtn".');
        return;
    }

    // Attach click handler to each .popupBtn
    popupButtons.forEach(btn => {
        btn.addEventListener('click', () => {
            let gramosValue;

            // Determine which pet button is active
            if (perroButton.classList.contains('active-text0001')) {
                gramosValue = perroGramosSpan?.textContent || '';
                console.log('PERRO is active. Collecting Main Extra Value.');
            } else if (gatoButton.classList.contains('active-text0001')) {
                gramosValue = gatoGramosSpan?.textContent || '';
                console.log('GATO is active. Collecting Main Extra Value.');
            } else {
                // Default to PERRO if neither is active
                gramosValue = perroGramosSpan?.textContent || '';
                console.log('No active button found. Defaulting to PERRO for Main Extra Value.');
            }

            // Save to localStorage
            if (gramosValue) {
                localStorage.setItem('Main Extra Value', gramosValue);
                console.log('Main Extra Value saved:', gramosValue);
            }

            // Update the display span
            const mainExtraValue = localStorage.getItem('Main Extra Value');
            if (gramosValueExtraSpan && mainExtraValue) {
                gramosValueExtraSpan.textContent = mainExtraValue;
                console.log('The grams span has been updated with the Main Extra Value.');
            }
        });
    });
});












  
  
  








// Calculation Div hide and show
  

document.addEventListener('DOMContentLoaded', () => {
    const mainPetDiv = document.querySelector('.mainpet');
     const gatoDiv = document.querySelector('.gatoxpro')
    const extraPetDiv = document.querySelector('.extrapet');
    const leftButton = document.querySelector('.left-button987');
    const rightButton = document.querySelector('.right-button987');
    const activebuttonxx = document.querySelector('.active-text0001');
    const gatoToggleButton = document.getElementById('gatoButton0001');
    const perroToggleButton = document.getElementById('perroButton0001');

    // Initially show the mainpet div and hide the other
    
    extraPetDiv.classList.add('hidden0001');

   


    // Event listener for the right button
    activebuttonxx.addEventListener('click', () => {
      
     extraPetDiv.classList.add('hidden0001X');
      console.log("Active button: XXXXX");
  
        
    });

    


    // Event listener for the right button
    rightButton.addEventListener('click', () => {
      
    
  // Find the active class and log it to the console
        if (perroToggleButton.classList.contains('active-text0001')) {
            console.log("Active button: PERRO");
               mainPetDiv.classList.add('hidden0001');
                   gatoDiv.classList.add('hidden0001');
              extraPetDiv.classList.remove('hidden0001');
                extraPetDiv.classList.remove('hidden0001X');
            
        } else {
            console.log("Active button: GATO");
                 gatoDiv.classList.add('hidden0001');
                    mainPetDiv.classList.add('hidden0001');
        extraPetDiv.classList.remove('hidden0001');
             extraPetDiv.classList.remove('hidden0001X');
          
        }
        
    });




// Event listener for the left button to show Gato or Perro.
leftButton.addEventListener('click', () => {
    // Find the active class and log it to the console
    if (perroToggleButton.classList.contains('active-text0001')) {
        console.log("Active button: PERRO");
        mainPetDiv.classList.remove('hidden0001');
        extraPetDiv.classList.add('hidden0001');
        gatoDiv.classList.add('hidden0001');
    } else {
        console.log("Active button: GATO");
        gatoDiv.classList.remove('hidden0001');
        mainPetDiv.classList.add('hidden0001');
        extraPetDiv.classList.add('hidden0001');
    }
});



});







// Buttons show and hide
















 // This function handles the selection of a button.
    function selectButton(buttonId) {
        // Get both buttons by their IDs.
        const simbaBtn = document.getElementById('simbaBtn');
        const appaBtn = document.getElementById('appaBtn');

        // Remove the 'selected-btn' class from both buttons to deselect them.
        simbaBtn.classList.remove('selected-btn');
        appaBtn.classList.remove('selected-btn');

        // Add the 'selected-btn' class to the button that was clicked.
        document.getElementById(buttonId).classList.add('selected-btn');
    }

    // This function handles removing the Appa button when the trash icon is clicked.
    function removeAppaButton(event) {
    
    }

    // This code runs when the page is fully loaded.
    document.addEventListener('DOMContentLoaded', () => {
        // Check if the Appa button is initially hidden.
        const appaBtn = document.getElementById('appaBtn');
        if (appaBtn.classList.contains('d-none')) {
            // If it's hidden, automatically select the Simba button.
            document.getElementById('simbaBtn').classList.add('selected-btn');
        }
    });




















function removeAppaButton(event) {





const activeButton = localStorage.getItem("active-button");
    const blueStyle = "color: blue; font-weight: bold;";

    if (activeButton === "PERRO") {
        const mismatchSpan = document.querySelector(".mismatchspan");
        const hasMismatchValue = mismatchSpan && mismatchSpan.textContent.trim() !== "";
        const bagsToSendElement = document.querySelector(".bagsToSend");
        const currentBags = parseInt(bagsToSendElement.textContent);
        const extraBagsValue = localStorage.getItem("Extra Bags Added Perro");
        const extraBagsAdded = extraBagsValue !== null ? parseInt(extraBagsValue) : null;

        console.log(
            "%cPERRO DEBUG | mismatchspan has value: %s | currentBags: %d | extraBags: %s",
            blueStyle,
            hasMismatchValue,
            currentBags,
            extraBagsAdded !== null ? extraBagsAdded : "MISSING"
        );

        // ✅ Only update if: NO mismatch error (span is empty) AND extra bags exist
        if (!hasMismatchValue && extraBagsValue !== null) {
            const newBags = currentBags - extraBagsAdded;
            bagsToSendElement.textContent = newBags;
            console.log("%cPERRO - ✅ Updated bagsToSend to: " + newBags, blueStyle);
        } else {
            console.log("%cPERRO - ❌ Skipped update (mismatch present or extra bags missing)", blueStyle);
        }
    }
    else if (activeButton === "GATO") {
        const mismatchSpanCat = document.querySelector(".mismatchspan-cat");
        const hasMismatchValue = mismatchSpanCat && mismatchSpanCat.textContent.trim() !== "";
        const bagsToSendCatElement = document.querySelector(".bagsToSend-cat");
        const currentBags = parseInt(bagsToSendCatElement.textContent);
        const extraBagsValue = localStorage.getItem("Extra Bags Added Gato");
        const extraBagsAdded = extraBagsValue !== null ? parseInt(extraBagsValue) : null;

        console.log(
            "%cGATO DEBUG | mismatchspan-cat has value: %s | currentBags: %d | extraBags: %s",
            blueStyle,
            hasMismatchValue,
            currentBags,
            extraBagsAdded !== null ? extraBagsAdded : "MISSING"
        );

        // ✅ Only update if: NO mismatch error (span is empty) AND extra bags exist
        if (!hasMismatchValue && extraBagsValue !== null) {
            const newBags = currentBags - extraBagsAdded;
            bagsToSendCatElement.textContent = newBags;
            console.log("%cGATO - ✅ Updated bagsToSend-cat to: " + newBags, blueStyle);
        } else {
            console.log("%cGATO - ❌ Skipped update (mismatch present or extra bags missing)", blueStyle);
        }
    }





    


    // === Gato Maxtotal Value ===
    const gatoValue = localStorage.getItem("Extra Bags Added Gato");
    localStorage.removeItem("Extra Bags Added Gato");

    // === Perro Maxtotal Value ===
    const perroValue = localStorage.getItem("Extra Bags Added Perro");
    localStorage.removeItem("Extra Bags Added Perro");









 const popupBtns = document.querySelectorAll('.popupBtn');
  const perroBtn = document.getElementById('perroButton0001');
  const gatoBtn = document.getElementById('gatoButton0001');

  // Unhide popup buttons
  popupBtns.forEach(btn => {
    btn.style.display = ''; // reset to default
  });

  // Unhide both pet buttons
  perroBtn.style.display = '';
  gatoBtn.style.display = '';

  // Clear saved state
  localStorage.removeItem('popupClicked');

  // Auto-click whichever has the active class
  if (perroBtn.classList.contains('active-text0001')) {
    perroBtn.click();
  } else if (gatoBtn.classList.contains('active-text0001')) {
    gatoBtn.click();
  }








    




   // Automatically click the button
  const button = document.querySelector('.left-button987');
  if (button) {
    button.click();
    console.log('Clicked on the .left-button987');
  } else {
    console.error('Error: Button with class ".left-button987" not found.');
  }
    // This line is removed to allow the default action to proceed.
    // event.preventDefault(); 
    
    // ⭐ START OF PRICE SUBTRACTION LOGIC
    const productPriceSpan = document.querySelector('.product-price-fixed-new');
    const petExtraPrice = parseFloat(localStorage.getItem("Total Extra Max")) || 0;

    if (productPriceSpan) {
        const currentPrice = parseFloat(productPriceSpan.textContent) || 0;
        const newTotalPrice = currentPrice - petExtraPrice;
        productPriceSpan.textContent = newTotalPrice.toFixed(2);
        console.log(`Updated .product-price-fixed: Subtracted $${petExtraPrice.toFixed(2)}. New total is $${newTotalPrice.toFixed(2)}.`);
    }
    
    // ⭐ END OF PRICE SUBTRACTION LOGIC



const BagsExtraValue = document.querySelector('.extrabags');
const BagsExtraValueN = document.querySelector('.extrabagsgato');




    // Remove each piece of data related to the extra pet from localStorage
    localStorage.removeItem("Extra Pet Type");
    localStorage.removeItem("Extra Pet Pet Name");
    localStorage.removeItem("Extra Pet Pet Breed");
    localStorage.removeItem("Extra Pet Pet Neutered");
    localStorage.removeItem("Extra Pet Pet Stage");
    localStorage.removeItem("Extra Pet Pet Weight");
    localStorage.removeItem("Extra Pet Pet Activity");
    localStorage.removeItem("Extra Pet Pet Allergies");
    localStorage.removeItem("Pet Extra Price"); // Also remove the price itself
    localStorage.removeItem("Extra Pet Main Price");
    localStorage.removeItem("Extra Pet Main Quantity");
     localStorage.removeItem("Total Extra Max");
   
    localStorage.removeItem("gramos-value-extra");
    localStorage.removeItem("Extra Pet Per Day");




     if (BagsExtraValue) {
        BagsExtraValue.textContent = '';
    }
     if (BagsExtraValueN) {
        BagsExtraValueN.textContent = '';
    }





    // Log to the console to confirm the data has been removed
    console.log("Extra Pet data has been removed from localStorage.");
    
    // Any other code you want to run
    // Stop the click event from bubbling up to the parent button,
    // which would otherwise select the button before it's removed.
    event.stopPropagation();

    // Get the Appa button by its ID.
    const appaBtn = document.getElementById('appaBtn');
    
    // Hide the Appa button by adding the 'd-none' class.
    appaBtn.classList.add('d-none');
    
    // Automatically select the Simba button after the Appa button is removed.
    selectButton('simbaBtn');
}



     // This function will remove the specific keys from localStorage.
    function clearExtraPetData() {
        localStorage.removeItem("Extra Pet Type");
        localStorage.removeItem("Extra Pet Pet Name");
        localStorage.removeItem("Extra Pet Pet Breed");
        localStorage.removeItem("Extra Pet Pet Neutered");
        localStorage.removeItem("Extra Pet Pet Stage");
        localStorage.removeItem("Extra Pet Pet Weight");
        localStorage.removeItem("Extra Pet Pet Activity");
         localStorage.removeItem("Pet Extra Price");
        localStorage.removeItem("Extra Pet Pet Allergies");
        console.log("Extra pet data has been cleared due to page load/reload.");
    }

    // Attach the function to the 'DOMContentLoaded' event.
    // This event fires when the initial HTML document has been completely loaded and parsed.
    document.addEventListener('DOMContentLoaded', clearExtraPetData);

    // Alternatively, you could use the 'beforeunload' event to clear data
    // just before the user leaves the page.
    window.addEventListener('beforeunload', clearExtraPetData);












// Function to get the price and save it to localStorage
function savePriceToLocalStorage() {
  const priceElement = document.querySelector('.product-price-fixed');
  
  if (priceElement) {
    const priceValue = priceElement.textContent.trim();
    // Save the value to localStorage with the key 'Total Gato Data'
    localStorage.setItem('Total Gato Data', priceValue);
    console.log('Price updated and saved to localStorage:', priceValue);
  }
}

// 1. Run the function when the page first loads
document.addEventListener('DOMContentLoaded', savePriceToLocalStorage);

// 2. Use a MutationObserver to watch for dynamic changes
const targetNode = document.querySelector('.product-price-fixed');

if (targetNode) {
  // Configure the observer to watch for changes in the element's content
  const config = {
    childList: true, // Watch for changes to the children of the element (e.g., a new text node)
    subtree: true,   // Watch for changes in sub-elements
    characterData: true, // Watch for changes to the text content itself
  };
  
  // Create a new MutationObserver instance
  const observer = new MutationObserver(savePriceToLocalStorage);
  
  // Start observing the target element with the specified configuration
  observer.observe(targetNode, config);
}

// Function to log the initial data and calculate the total
function logInitialDataAndTotal() {
  const gatoData = parseFloat(localStorage.getItem('Total Gato Data')) || 0;
  const petPrice = parseFloat(localStorage.getItem('Total Extra Max')) || 0;
  const savedTotal = parseFloat(localStorage.getItem('Saved total')) || 0;

  console.log('--- Initial Local Storage Data ---');
  console.log('Total Gato Data:', gatoData);
  console.log('Total Extra Max:', petPrice);
  console.log('Saved total:', savedTotal);
  console.log('-----------------------------------');
}

// Log initial data when the script first runs
logInitialDataAndTotal();

// Listen for our custom 'localStorageChange' event
window.addEventListener('localStorageChange', (event) => {
  const { key, oldValue, newValue } = event.detail;

  // Check if either of the target keys changed
  if (key === 'Total Gato Data' || key === 'Total Extra Max') {
    console.log(`The key "${key}" has changed!`);
    console.log('Old value:', oldValue);
    console.log('New value:', newValue);

    // Get the updated values and calculate the new total
    const gatoData = parseFloat(localStorage.getItem('Total Gato Data')) || 0;
    const petPrice = parseFloat(localStorage.getItem('Total Extra Max')) || 0;
    const newTotal = gatoData + petPrice;

    // Fix: Round the total to two decimal places
    const fixedTotal = newTotal.toFixed(2); 

    // Display the addition equation in the console
    console.log(`${gatoData} + ${petPrice} = ${fixedTotal}`);

    // Save the new total to local storage
    localStorage.setItem('Saved total', fixedTotal);

    console.log('New total saved as "Saved total".');

    // Update the span element with the new total after 0.5 seconds
    setTimeout(() => {
      const newPriceSpan = document.querySelector('.product-price-fixed-new');
      if (newPriceSpan) {
        newPriceSpan.textContent = fixedTotal;
        console.log('The new span has been updated with the total after a delay.');
      }
    }, 500); // 500 milliseconds = 0.5 seconds

    console.log('-----------------------------------');
  }
});

// Override the native localStorage.setItem method
const originalSetItem = localStorage.setItem;

localStorage.setItem = function(key, value) {
  const oldValue = this.getItem(key);
  originalSetItem.apply(this, arguments);

  const event = new CustomEvent('localStorageChange', {
    detail: {
      key: key,
      oldValue: oldValue,
      newValue: value,
      url: window.location.href,
    },
  });

  window.dispatchEvent(event);
};












document.addEventListener('DOMContentLoaded', () => {

    const updatePerroTotal = () => {
        const catPriceSpan = document.querySelector('.product-price-fixed-cat');
        const newTotalSpan = document.querySelector('.product-price-fixed-cat-new');

        const catPriceText = catPriceSpan ? catPriceSpan.textContent : '0';
        const petExtraPriceText = localStorage.getItem("Pet Extra Price");

        const catPrice = parseFloat(catPriceText.replace(/[^0-9.]/g, '')) || 0;
        const petExtraPrice = petExtraPriceText !== null ? parseFloat(petExtraPriceText) || 0 : 0;

        let newTotal;

        if (petExtraPriceText === null) {
            // No extra price yet → just match the cat price
            newTotal = catPrice;
        } else {
            // Extra price exists → add it
            newTotal = catPrice + petExtraPrice;
        }

        const formattedTotal = newTotal.toFixed(2);

        // Log values in console
        console.groupCollapsed("--- Perro Total Calculation ---");
        console.log(`Cat price (.product-price-fixed-cat): $${catPrice.toFixed(2)}`);
        console.log(`Pet Extra Price (localStorage): ${petExtraPriceText !== null ? "$" + petExtraPrice.toFixed(2) : "Not set"}`);
        console.log(`Final total (.product-price-fixed-cat-new): $${formattedTotal}`);
        console.groupEnd();

        // Update span
        if (newTotalSpan) {
            newTotalSpan.textContent = formattedTotal;
            console.log("✅ .product-price-fixed-cat-new updated with:", formattedTotal);
        } else {
            console.warn("⚠️ WARNING: The element '.product-price-fixed-cat-new' was not found.");
        }
    };

    // Run once on page load → ensures default matches cat price
    updatePerroTotal();

    // ---- Detect localStorage changes in the same tab ----
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, value) {
        originalSetItem.apply(this, arguments);
        if (key === "Pet Extra Price") {
            updatePerroTotal();
        }
    };

    const originalRemoveItem = localStorage.removeItem;
    localStorage.removeItem = function (key) {
        originalRemoveItem.apply(this, arguments);
        if (key === "Pet Extra Price") {
            updatePerroTotal();
        }
    };

    // ---- Handle cross-tab changes ----
    window.addEventListener('storage', (event) => {
        if (event.key === "Pet Extra Price") {
            updatePerroTotal();
        }
    });

    // ---- Add button click triggers ----
    const perroButton = document.getElementById('perroButton0001');
    const gatoButton = document.getElementById('gatoButton0001');

    if (perroButton) {
        perroButton.addEventListener('click', updatePerroTotal);
    } else {
        console.warn("⚠️ WARNING: The button with ID 'perroButton0001' was not found.");
    }

    if (gatoButton) {
        gatoButton.addEventListener('click', updatePerroTotal);
    } else {
        console.warn("⚠️ WARNING: The button with ID 'gatoButton0001' was not found.");
    }

});










document.addEventListener('DOMContentLoaded', () => {
    // Select the existing spans for gramos
    const perroGramosSpan = document.querySelector('.gramos-value');
    const gatoGramosSpan = document.querySelector('.cat-gramos-value');

    // Select the new spans for frequency
    const perroFrequencySpan = document.querySelector('.frequency-option');
    const gatoFrequencySpan = document.querySelector('.cat-frequency-option');

    // Check if all necessary elements exist
    if (perroGramosSpan && gatoGramosSpan && perroFrequencySpan && gatoFrequencySpan) {
        const saveToLocalStorage = () => {
            // Get the text content from all four spans
            const perroGramosValue = perroGramosSpan.textContent;
            const gatoGramosValue = gatoGramosSpan.textContent;
            const perroFrequencyValue = perroFrequencySpan.textContent;
            const gatoFrequencyValue = gatoFrequencySpan.textContent;

            // Save all values to localStorage
            localStorage.setItem('PERRO gramos value', perroGramosValue);
            localStorage.setItem('Gato gramos value', gatoGramosValue);
            localStorage.setItem('PERRO frequency value', perroFrequencyValue);
            localStorage.setItem('Gato frequency value', gatoFrequencyValue);

            console.log('Values updated and saved to localStorage:', {
                'PERRO gramos value': perroGramosValue,
                'Gato gramos value': gatoGramosValue,
                'PERRO frequency value': perroFrequencyValue,
                'Gato frequency value': gatoFrequencyValue
            });
        };

        // Create a new MutationObserver instance with a single callback
        const observer = new MutationObserver(saveToLocalStorage);

        // Options for the observer:
        const config = {
            childList: true,
            characterData: true,
            subtree: true,
        };

        // Initial save on page load
        saveToLocalStorage();

        // Start observing all four spans for changes
        observer.observe(perroGramosSpan, config);
        observer.observe(gatoGramosSpan, config);
        observer.observe(perroFrequencySpan, config);
        observer.observe(gatoFrequencySpan, config);

        console.log('Now observing all four spans for changes...');

    } else {
        console.log('One or more spans were not found on the page.');
    }
});























document.addEventListener('DOMContentLoaded', () => {

    // Select all the relevant elements
    const perroFrequencySpan = document.querySelector('.frequency-option');
    const gatoFrequencySpan = document.querySelector('.cat-frequency-option');
    const perroButton = document.getElementById('perroButton0001');
    const gatoButton = document.getElementById('gatoButton0001');
    const frequencyOptionExtraSpan = document.querySelector('.frequency-option-extra');

    // This function keeps the "frequency-option-extra" span in sync with the localStorage value
    const syncFrequencySpan = () => {
        const mainFrequencyValue = localStorage.getItem('Main frequency Value');
        if (frequencyOptionExtraSpan && mainFrequencyValue) {
            frequencyOptionExtraSpan.textContent = mainFrequencyValue;
            console.log('Updated "frequency-option-extra" span with value from localStorage.');
        }
    };
    
    // This function updates the Main frequency value based on the active button
    const updateMainFrequencyValue = () => {
        let frequencyValue;
        let activeButtonStatus;

        if (perroButton && perroButton.classList.contains('active-text0001')) {
            frequencyValue = perroFrequencySpan.textContent;
            activeButtonStatus = 'PERRO';
            console.log('PERRO is active. Updating Main frequency value.');
        } else if (gatoButton && gatoButton.classList.contains('active-text0001')) {
            frequencyValue = gatoFrequencySpan.textContent;
            activeButtonStatus = 'GATO';
            console.log('GATO is active. Updating Main frequency value.');
        } else {
            // Default to PERRO's data if no button has the active class
            if (perroFrequencySpan) {
                frequencyValue = perroFrequencySpan.textContent;
            }
            activeButtonStatus = 'PERRO';
            console.log('Defaulting to PERRO as active.');
        }

        // Save the values to localStorage
        localStorage.setItem('Main frequency Value', frequencyValue);
        localStorage.setItem('active-button', activeButtonStatus);
        
        console.log('Main frequency Value saved:', frequencyValue);

        // After updating localStorage, sync the display span
        syncFrequencySpan();
    };

    // --- MutationObserver to watch for changes to the frequency spans ---
    const observerCallback = (mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'characterData' || mutation.type === 'childList') {
                updateMainFrequencyValue();
            }
        }
    };
    
    const observer = new MutationObserver(observerCallback);
    const config = { childList: true, characterData: true, subtree: true };

    if (perroFrequencySpan && gatoFrequencySpan) {
        observer.observe(perroFrequencySpan, config);
        observer.observe(gatoFrequencySpan, config);
        console.log('Now observing frequency spans for changes.');
    }
    
    // Initial call to set the default state on page load
    updateMainFrequencyValue();
    
    // Add click event listeners to update the active class on buttons
    if (perroButton && gatoButton) {
        perroButton.addEventListener('click', () => {
            perroButton.classList.add('active-text0001');
            gatoButton.classList.remove('active-text0001');
            updateMainFrequencyValue();
        });
        gatoButton.addEventListener('click', () => {
            gatoButton.classList.add('active-text0001');
            perroButton.classList.remove('active-text0001');
            updateMainFrequencyValue();
        });
    } else {
        console.error('Required buttons not found.');
    }
});




document.addEventListener('DOMContentLoaded', () => {
    // Select the necessary spans to observe
    const gramosValueExtraSpan = document.querySelector('.gramos-value-extra');
    const frequencyOptionExtraSpan = document.querySelector('.frequency-option-extra');

    // Select the span to update with the new price
    const pricePerDayExtraSpan = document.querySelector('.price-per-day-discounted-extra');

    // Function to perform the calculation and update the price
    const calculateAndSavePrice = () => {
        // Collect span data
        const gramsValueText = gramosValueExtraSpan?.textContent || '';
        const frequencyValueText = frequencyOptionExtraSpan?.textContent || '';

        // Collect localStorage data
        const catPlanPrice = parseFloat(localStorage.getItem('Cat Plan Price'));
        const catPlanQuantity = parseFloat(localStorage.getItem('Cat Plan Quantity'));
        const dogPlanPrice = parseFloat(localStorage.getItem('Dog Plan Price'));
        const dogPlanQuantity = parseFloat(localStorage.getItem('Dog Plan Quantity'));
        const popupClicked = localStorage.getItem('popupClicked'); // 👈 Use this instead of 'active-button'

        // Extract numerical values from text content
        const gramsValue = parseFloat(gramsValueText.replace(/[^\d.]/g, '')) || 0;
        const frequencyValue = parseFloat(frequencyValueText.replace(/[^\d.]/g, '')) || 0;

        if (!gramsValue || !frequencyValue || popupClicked === null) {
            console.error('Missing required data for calculation.');
            return;
        }

        let mainExtraPrice = 0;
        let dailyGrams = 0;

        console.log("--- Starting Calculation ---");
        console.log(`Grams Value: ${gramsValue}`);
        console.log(`Frequency Value: ${frequencyValue}`);
        console.log(`popupClicked: "${popupClicked}" (0=Gato, 1=Perro)`);

   // ✅ Formula: gramsValue * 7 * frequencyValue
dailyGrams = gramsValue * 7 * frequencyValue;
console.log(`Daily Grams (gramsValue * 7 * frequencyValue): ${gramsValue} * 7 * ${frequencyValue} = ${dailyGrams}`);

// Helper: round up if decimal > 0.1, otherwise keep integer part
function smartRound(num) {
    return Math.floor(num) + (num % 1 > 0.1 ? 1 : 0);
}

if (popupClicked === '1') { // 👈 '1' = Perro
    if (dogPlanQuantity && dogPlanPrice && dogPlanQuantity !== 0) {
        let baseUnits = dailyGrams / dogPlanQuantity;
        let roundedUnits = smartRound(baseUnits);
        mainExtraPrice = roundedUnits * dogPlanPrice;
        console.log(`PERRO Calculation: (dailyGrams / dogPlanQuantity) → round → * dogPlanPrice`);
        console.log(`Step-by-step: (${dailyGrams} / ${dogPlanQuantity}) = ${baseUnits} → rounded to ${roundedUnits} → * ${dogPlanPrice} = ${mainExtraPrice}`);
    } else {
        console.error('Missing or invalid Dog Plan data in localStorage.');
    }
} else if (popupClicked === '0') { // 👈 '0' = Gato
    if (catPlanQuantity && catPlanPrice && catPlanQuantity !== 0) {
        let baseUnits = dailyGrams / catPlanQuantity;
        let roundedUnits = smartRound(baseUnits);
        mainExtraPrice = roundedUnits * catPlanPrice;
        console.log(`GATO Calculation: (dailyGrams / catPlanQuantity) → round → * catPlanPrice`);
        console.log(`Step-by-step: (${dailyGrams} / ${catPlanQuantity}) = ${baseUnits} → rounded to ${roundedUnits} → * ${catPlanPrice} = ${mainExtraPrice}`);
    } else {
        console.error('Missing or invalid Cat Plan data in localStorage.');
    }
} else {
    console.error(`Invalid popupClicked value: "${popupClicked}". Expected "0" or "1".`);
    return;
}

        // Save the calculated price to localStorage
        localStorage.setItem('MExtra Per week', mainExtraPrice.toFixed(2));
        console.log(`MExtra Per week saved to localStorage: ${mainExtraPrice.toFixed(2)}`);
        console.log("--- Calculation Complete ---");

        // Update the price display span
        // Update the price display span
    if (pricePerDayExtraSpan) {
    // 1. Calculate the full-precision value
    const fullPrice = mainExtraPrice / frequencyValue;
    
    // 2. SAVE the full, unrounded value to localStorage
    localStorage.setItem('FullExtraPrice', fullPrice.toString());
    console.log('Saved full price to localStorage:', fullPrice); // Optional log for confirmation

    // 3. DISPLAY the rounded value in the span for the user
    pricePerDayExtraSpan.textContent = fullPrice.toFixed(2);
}

    };

    // Set up the MutationObserver to watch for changes in the spans
    const observer = new MutationObserver(calculateAndSavePrice);
    const config = { childList: true, characterData: true, subtree: true };

    if (gramosValueExtraSpan && frequencyOptionExtraSpan) {
        observer.observe(gramosValueExtraSpan, config);
        observer.observe(frequencyOptionExtraSpan, config);
        console.log('Now observing spans for automatic price calculation.');
    }

    // Run the calculation once on page load to set the initial value
    calculateAndSavePrice();
});



        const keyToRemove = 'Total Extra Max';
        localStorage.removeItem(keyToRemove);
        console.log(`Page load script: Removed localStorage key: "${keyToRemove}" after 1 second.`);



document.addEventListener('DOMContentLoaded', () => {
    const logRed = (...args) => console.log('%c' + args.join(' '), 'color: red; font-weight: bold;');

    // Select elements
    const frequencyOptionExtraSpan = document.querySelector('.frequency-option-extra');
    const dogFixedPriceSpan = document.querySelector('.product-price-fixed');
    const catFixedPriceSpan = document.querySelector('.product-price-fixed-cat');
    const dogNewPriceSpan = document.querySelector('.product-price-fixed-new');
    const catNewPriceSpan = document.querySelector('.product-price-fixed-cat-new');
    const appaPriceMaxSpan = document.querySelector('.appapricemax');
    const perroButton = document.getElementById('perroButton0001');
    const gatoButton = document.getElementById('gatoButton0001');
    const appaBtn = document.getElementById('appaBtn');

  // 🔁 Main calculation function
    const calculateAndUpdatePrices = () => {
        
        // 1. Check Pet Active Status (Keep existing logic)
        const isPerroActive = perroButton?.classList.contains('active-text0001');
        const isGatoActive = gatoButton?.classList.contains('active-text0001');

        if (!isPerroActive && !isGatoActive) {
            logRed('No active pet button. Skipping.');
            return;
        }

        // 2. Initialize Extra Price to 0
        let totalExtraMax = 0;

        // 3. Check if Appa Button is visible
        const isAppaVisible = appaBtn && !appaBtn.classList.contains('d-none');

        // 4. IF Appa is visible, run the original calculation logic
        if (isAppaVisible) {
            const fullExtraPriceStr = localStorage.getItem('FullExtraPrice');
            const frequencyValueText = frequencyOptionExtraSpan?.textContent || '';

            const pricePerDay = parseFloat(fullExtraPriceStr);
            const frequencyValue = parseFloat(frequencyValueText.replace(/[^\d.]/g, ''));

            if (isNaN(pricePerDay) || isNaN(frequencyValue)) {
                logRed('Invalid data: FullExtraPrice or frequency missing.');
                return;
            }

            totalExtraMax = pricePerDay * frequencyValue;
        } else {
            // IF Appa is hidden, we log it, but we DO NOT return. We keep totalExtraMax at 0.
            logRed("appaBtn is hidden. Setting extra price to 0 and continuing...");
        }

        // 5. Update Storage and Extra Span (Runs even if 0)
        localStorage.setItem('Total Extra Max', totalExtraMax.toFixed(2));

        if (appaPriceMaxSpan) {
            appaPriceMaxSpan.textContent = totalExtraMax.toFixed(2);
            logRed(`✅ Updated .appapricemax = ${totalExtraMax.toFixed(2)}`);
        }

        // 6. Update dog/cat total (Runs even if Appa is hidden)
        let finalTotalPrice;
        if (isPerroActive) {
            const dogBasePrice = parseFloat(dogFixedPriceSpan?.textContent.replace(/[^\d.]/g, '') || '');
            if (!isNaN(dogBasePrice)) {
                finalTotalPrice = dogBasePrice + totalExtraMax; // Adds 0 if Appa hidden
                if (dogNewPriceSpan) dogNewPriceSpan.textContent = finalTotalPrice.toFixed(2);
                localStorage.setItem('Product Total Price', finalTotalPrice.toFixed(2));
            }
        } else if (isGatoActive) {
            const catBasePrice = parseFloat(catFixedPriceSpan?.textContent.replace(/[^\d.]/g, '') || '');
            if (!isNaN(catBasePrice)) {
                finalTotalPrice = catBasePrice + totalExtraMax; // Adds 0 if Appa hidden
                if (catNewPriceSpan) catNewPriceSpan.textContent = finalTotalPrice.toFixed(2);
                localStorage.setItem('Product Total Price', finalTotalPrice.toFixed(2));
            }
        }
    };

    // 🕵️‍♂️ 1. Observe frequency span changes (DOM)
    const observer = new MutationObserver(calculateAndUpdatePrices);
    const config = { childList: true, characterData: true, subtree: true };
    if (frequencyOptionExtraSpan) {
        observer.observe(frequencyOptionExtraSpan, config);
    }

    // 🕵️‍♂️ 2. Observe localStorage['FullExtraPrice'] changes (custom)
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function(key, value) {
        // Call original
        const result = originalSetItem.apply(this, arguments);

        // If FullExtraPrice changed, trigger recalc
        if (key === 'FullExtraPrice') {
            logRed("Detected change in localStorage['FullExtraPrice'] → recalculating prices...");
            calculateAndUpdatePrices();
        }

        return result;
    };

    // 🔄 Run once on load (with small delay to ensure DOM + LS are ready)
    setTimeout(calculateAndUpdatePrices, 300);
});




document.addEventListener('DOMContentLoaded', () => {
    console.log('✅ [DEBUG] Extra Bags Calculator: Script loaded.');

    // === SELECT ELEMENTS ===
    const gramosValueExtraSpan = document.querySelector('.gramos-value-extra');
    const frequencyOptionExtraSpan = document.querySelector('.frequency-option-extra');
    const perroDisplaySpan = document.querySelector('.bagsToSend');
    const gatoDisplaySpan = document.querySelector('.bagsToSend-cat');
    const totalBagsSpan = document.querySelector('.total-extra-bags');
    const perroMismatchSpan = document.querySelector('.mismatchspan');      // 👈 For Perro mismatch
    const gatoMismatchSpan = document.querySelector('.mismatchspan-cat');   // 👈 For Gato mismatch
    const appaBtn = document.getElementById('appaBtn');
    const perroButton = document.getElementById('perroButton0001');
    const gatoButton = document.getElementById('gatoButton0001');
    const appaPriceMaxSpan = document.querySelector('.appapricemax');
    const perroPriceSpan = document.querySelector('.product-price-fixed');
    const gatoPriceSpan = document.querySelector('.product-price-fixed-cat');

    // ➤ Exit early if critical spans missing
    if (!gramosValueExtraSpan || !frequencyOptionExtraSpan || !appaPriceMaxSpan) {
        console.warn('⚠️ [DEBUG] Required input spans not found. Skipping.');
        return;
    }

    let observer = null;

    // ✅ Function to CLEAR both mismatch spans
    const clearMismatchDisplays = () => {
        if (perroMismatchSpan) perroMismatchSpan.textContent = '';
        if (gatoMismatchSpan) gatoMismatchSpan.textContent = '';
    };

    // === MAIN CALCULATION FUNCTION ===
    const calculateAndSavePrice = (triggeredByAppaMax = false) => {
        try {
            // 🚫 SKIP if #appaBtn is hidden
            if (!appaBtn || appaBtn.classList.contains('d-none')) {
                clearMismatchDisplays();
                console.log('🙈 [DEBUG] #appaBtn is missing or has .d-none — CLEARED mismatch spans.');
                return;
            }

            console.log('\n--- 🧮 [DEBUG] 🐶🐱 STARTING CALCULATION ---');

            // === 1. PARSE GRAMS & FREQUENCY ===
            const gramsValueText = gramosValueExtraSpan.textContent || '';
            const frequencyValueText = frequencyOptionExtraSpan.textContent || '';
            const gramsValue = parseFloat(gramsValueText.replace(/[^\d.]/g, '')) || 0;
            const frequencyValue = parseFloat(frequencyValueText.replace(/[^\d.]/g, '')) || 0;

            console.log(`[DEBUG] 📏 .gramos-value-extra: "${gramsValueText}" → ${gramsValue}`);
            console.log(`[DEBUG] 🔄 .frequency-option-extra: "${frequencyValueText}" → ${frequencyValue}`);

            if (!gramsValue || !frequencyValue) {
                console.warn('⚠️ [DEBUG] Invalid grams or frequency. Aborting.');
                return;
            }

            // === 2. GET PLAN PRICES FROM LOCALSTORAGE ===
            const dogPlanPrice = parseFloat(localStorage.getItem('Dog Plan Price')) || 0;
            const catPlanPrice = parseFloat(localStorage.getItem('Cat Plan Price')) || 0;
            const popupClicked = localStorage.getItem('popupClicked');

            console.log(`[DEBUG] 💰 Dog Plan Price (localStorage): ${dogPlanPrice}`);
            console.log(`[DEBUG] 💰 Cat Plan Price (localStorage): ${catPlanPrice}`);
            console.log(`[DEBUG] 🖱️ popupClicked (localStorage): "${popupClicked}"`);

            // === 3. ✅ ALWAYS READ & CALCULATE PERRO & GATO MAIN BAGS ===
            let perroMainBags = 0;
            let gatoMainBags = 0;

            if (perroPriceSpan) {
                const perroPriceText = perroPriceSpan.textContent || '';
                const perroNewPriceValue = parseFloat(perroPriceText.replace(/[^\d.]/g, '')) || 0;
                console.log(`[DEBUG] 🐶 .product-price-fixed: "${perroPriceText}" → ${perroNewPriceValue}`);
                if (dogPlanPrice) {
                    perroMainBags = Math.round(perroNewPriceValue / dogPlanPrice);
                    console.log(`[DEBUG] 🧮 Perro Main Bags = Math.round(${perroNewPriceValue} / ${dogPlanPrice}) = ${perroMainBags}`);
                }
            }

            if (gatoPriceSpan) {
                const gatoPriceText = gatoPriceSpan.textContent || '';
                const gatoNewPriceValue = parseFloat(gatoPriceText.replace(/[^\d.]/g, '')) || 0;
                console.log(`[DEBUG] 🐱 .product-price-fixed-cat: "${gatoPriceText}" → ${gatoNewPriceValue}`);
                if (catPlanPrice) {
                    gatoMainBags = Math.round(gatoNewPriceValue / catPlanPrice);
                    console.log(`[DEBUG] 🧮 Gato Main Bags = Math.round(${gatoNewPriceValue} / ${catPlanPrice}) = ${gatoMainBags}`);
                }
            }

            // === 4. ✅ READ APPAPRICEMAX & CALCULATE EXTRA BAGS ===
            const appaPriceMaxText = appaPriceMaxSpan.textContent || '';
            const appaPriceMaxValue = parseFloat(appaPriceMaxText.replace(/[^\d.]/g, '')) || 0;
            console.log(`[DEBUG] 💹 .appapricemax: "${appaPriceMaxText}" → ${appaPriceMaxValue}`);

            let extraBags = 0;
            let extraCalculation = '';
            let gramLabel = '500gr'; // Default for Perro

          if (popupClicked === '1' && dogPlanPrice) {
    extraBags = Math.round(appaPriceMaxValue / dogPlanPrice);
    extraCalculation = `Math.round(${appaPriceMaxValue} / ${dogPlanPrice}) = ${extraBags}`;
    gramLabel = '500gr'; // Perro
    console.log(`[DEBUG] ➕ Extra Bags (Perro Plan): ${extraCalculation}`);
    
    // ✅ Save to localStorage for Perro
    localStorage.setItem('Extra Bags Added Perro', extraBags.toString());

} else if (popupClicked === '0' && catPlanPrice) {
    extraBags = Math.round(appaPriceMaxValue / catPlanPrice);
    extraCalculation = `Math.round(${appaPriceMaxValue} / ${catPlanPrice}) = ${extraBags}`;
    gramLabel = '200gr'; // Gato
    console.log(`[DEBUG] ➕ Extra Bags (Gato Plan): ${extraCalculation}`);
    
    // ✅ Save to localStorage for Gato
    localStorage.setItem('Extra Bags Added Gato', extraBags.toString());
}

            // === 5. CHECK ACTIVE BUTTON ===
            const isPerroActive = perroButton?.classList.contains('active-text0001') || false;
            const isGatoActive = gatoButton?.classList.contains('active-text0001') || false;

            console.log(`[DEBUG] 🎯 Perro active: ${isPerroActive}`);
            console.log(`[DEBUG] 🎯 Gato active: ${isGatoActive}`);

            // === 6. CHECK MATCH ===
            let isMatch = false;
            if (popupClicked === '1' && isPerroActive) isMatch = true;
            if (popupClicked === '0' && isGatoActive) isMatch = true;

            console.log(`[DEBUG] 🔄 Match? ${isMatch}`);

            // === 7. ✅ BUILD DISPLAY LOGIC ===

            // ➤ Always clear mismatch spans first
            clearMismatchDisplays();

if (isPerroActive) {
    if (isMatch) {
        // ✅ MATCH: Update .bagsToSend with total
        const total = perroMainBags + extraBags;
        if (perroDisplaySpan) {
            perroDisplaySpan.textContent = total.toString();
            console.log(`✅ [DEBUG] 📤 MATCH → Updated .bagsToSend → "${total}"`);
        }
        // ✅ Save Perro values to localStorage
        localStorage.setItem('Extra Bags Added Perro', extraBags.toString());
        localStorage.setItem('Perro Original Bags', perroMainBags.toString());
        // Optional: clear Gato values to avoid stale data
        localStorage.removeItem('Extra Bags Added Gato');
        localStorage.removeItem('Gato Original Bags');

    } else {
        // ❌ MISMATCH: Only update UI, no localStorage save
        if (perroMismatchSpan) {
            const mismatchText = `+ Extra ${extraBags} paquetes de ${gramLabel}`;
            perroMismatchSpan.textContent = mismatchText;
            console.log(`✅ [DEBUG] 📤 MISMATCH → Updated .mismatchspan → "${mismatchText}"`);
        }
    }
} else if (isGatoActive) {
    if (isMatch) {
        // ✅ MATCH: Update .bagsToSend-cat with total
        const total = gatoMainBags + extraBags;
        if (gatoDisplaySpan) {
            gatoDisplaySpan.textContent = total.toString();
            console.log(`✅ [DEBUG] 📤 MATCH → Updated .bagsToSend-cat → "${total}"`);
        }
        // ✅ Save Gato values to localStorage
        localStorage.setItem('Extra Bags Added Gato', extraBags.toString());
        localStorage.setItem('Gato Original Bags', gatoMainBags.toString());
        // Optional: clear Perro values
        localStorage.removeItem('Extra Bags Added Perro');
        localStorage.removeItem('Perro Original Bags');

    } else {
        // ❌ MISMATCH: Only update UI, no localStorage save
        if (gatoMismatchSpan) {
            const mismatchText = `+ Extra ${extraBags} paquetes de ${gramLabel}`;
            gatoMismatchSpan.textContent = mismatchText;
            console.log(`✅ [DEBUG] 📤 MISMATCH → Updated .mismatchspan-cat → "${mismatchText}"`);
        }
    }
}

            // === 8. UPDATE TOTAL SPAN (Main Perro + Main Gato) ===
            const totalBags = perroMainBags + gatoMainBags;
            if (totalBagsSpan) {
                totalBagsSpan.textContent = totalBags.toString();
                console.log(`✅ [DEBUG] 📤 Updated .total-extra-bags → "${totalBags}"`);
            }

            // === 9. SAVE TO LOCALSTORAGE ===
            localStorage.setItem('Total Extra Bags', totalBags.toString());
            localStorage.setItem('Max Extra Bags Perro', perroMainBags.toString());
            localStorage.setItem('Max Extra Bags Gato', gatoMainBags.toString());

            console.log('--- ✅ [DEBUG] 🐶🐱 CALCULATION COMPLETE ---\n');

        } catch (err) {
            console.error('🔥 [DEBUG] Error in calculation:', err);
        }
    };

    // === SET UP OBSERVER ===
    const startObserver = () => {
        if (observer) observer.disconnect();

        observer = new MutationObserver((mutations) => {
            let triggeredByAppaMax = false;
            for (let mutation of mutations) {
                if (mutation.target === appaPriceMaxSpan) {
                    triggeredByAppaMax = true;
                    break;
                }
            }
            setTimeout(() => calculateAndSavePrice(triggeredByAppaMax), 100);
        });

        const config = { childList: true, characterData: true, subtree: true };

        // Observe main triggers
        observer.observe(gramosValueExtraSpan, config);
        observer.observe(frequencyOptionExtraSpan, config);
        observer.observe(appaPriceMaxSpan, config);

        // Observe price spans
        if (perroPriceSpan) observer.observe(perroPriceSpan, config);
        if (gatoPriceSpan) observer.observe(gatoPriceSpan, config);

        // Observe button visibility
        if (appaBtn) {
            observer.observe(appaBtn, { attributes: true, attributeFilter: ['class'] });
        }

        console.log('✅ [DEBUG] Observers attached.');
    };

    // Run once at start
    calculateAndSavePrice();

    // Start observing
    startObserver();
});














// Set a timeout to delay the execution of the collection and removal by 2 seconds
  setTimeout(function() {
    
    // === Gato Maxtotal Value ===
    const gatoValue = localStorage.getItem("Extra Bags Added Gato");
    localStorage.removeItem("Extra Bags Added Gato");

    // === Perro Maxtotal Value ===
    const perroValue = localStorage.getItem("Extra Bags Added Perro");
    localStorage.removeItem("Extra Bags Added Perro");
       localStorage.removeItem("Gato Original Bags");

  
    
   

    logStatus("Gato Maxtotal Value", gatoValue);
    logStatus("Perro Maxtotal Value", perroValue);
    logStatus("Pet Extra Price", petExtraPriceValue);

  }, 500); // 500 milliseconds = .5 seconds










